<template>
    <a-modal title="退票" v-model="tuipiaoData.show" @ok="doSubmit" @cancel="cancelSubmit" okText="确定" cancelText="取消">
        <a-form :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-form-item label="备注">
                <a-textarea v-model="tuipiaoData.tuipiaoDesc" placeholder="请填写备注" />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<style lang="scss" scoped>

</style>

<script>
export default {
    props: ['id'],
    data() {
        return {
            formItemLayout: {
                labelCol: {
                    span: 4,
                },
                wrapperCol: {
                    span: 20,
                },
            },
            tuipiaoData: {
                show: true,
                tuipiaoDesc: ''
            }
        };
    },
    async created() {
    },
    methods: {
        cancelSubmit() {
            this.$emit('modelCallBack', {status: -1})
        },
        async doSubmit() {
            const that = this
            const r = await this.$axios.post("/exh/menpiao/updateMenpiaoRecordStatus", {
                id: this.id,
                status: -1,
                tuipiaoDesc: that.tuipiaoData.tuipiaoDesc
            });
            if (r.status == 1) {
                // this.$message.success('操作成功')
                this.$emit('modelCallBack', {status: 1})
            } else {
                this.$message.error('操作失败...')
            }
        },
    },
};
</script>